// extracted by mini-css-extract-plugin
export default {"container":"CardOfProject_container__F3Vem","buttonInProjectCard":"CardOfProject_buttonInProjectCard__pSvOt","iconEyes":"CardOfProject_iconEyes__+C2kb"};